import { Heading } from "@ubnt/ui-components/aria";
import { SsoApi } from "../api/SsoApi";
import { useState } from "react";
import { getErrorMessage } from "../utils/getErrorMessage";
import { handleRedirect } from "../utils/handleRedirect";
import { Loader } from "@ubnt/ui-components/Loader";
import { Description, MainWrapper, StyledConfirmationCode } from "./styles";

type ActivateFormProps = {
  setSuccessState: React.Dispatch<
    React.SetStateAction<{
      deviceName: string | null;
      isSuccess: boolean;
    }>
  >;
};
const ssoApi = new SsoApi();

export const ActivateForm: React.FC<ActivateFormProps> = ({
  setSuccessState,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState<string | undefined>(undefined);

  const handleSubmit = async (value: string) => {
    try {
      const { data } = await ssoApi.invokeSSOTokenSetup(value);

      await ssoApi.approveLoginToken(value);

      setSuccessState({ deviceName: data.device_name, isSuccess: true });
    } catch (error) {
      console.error(error);
      const { shouldRedirect, message } = getErrorMessage(error);
      setApiError(message);

      if (shouldRedirect) {
        handleRedirect();
      }
    }
  };

  const handleComplete = async (token: string) => {
    setIsLoading(true);
    await handleSubmit(token);
    setIsLoading(false);
  };

  const handleChange = () => setApiError("");

  return (
    <MainWrapper>
      <Heading size="xlarge-1">Enter Code</Heading>
      <Description size="medium">
        Enter the code displayed on your device.
      </Description>
      <StyledConfirmationCode
        tokens={5}
        type="text"
        helperMessage={apiError}
        invalid={!!apiError}
        onChange={handleChange}
        onComplete={handleComplete}
        disabled={isLoading}
        data-testid={"activate-confirmation-code"}
      />
      {isLoading ? <Loader type="spinner" size="large" /> : <></>}
    </MainWrapper>
  );
};
